module.exports = __webpack_public_path__ + "static/media/ruta-2560.4ff168a5.webp";